<template>
	<div class="service-menu">
		<AmeliproIconBtn
			id="service-menu-btn"
			btn-label="Bouquet de services"
			class="service-menu__btn"
			:icon="icon"
			icon-bg-color="ap-blue darken-1"
			icon-color="ap-white"
			icon-hover-bg-color="ap-blue darken-2"
			icon-hover-color="ap-white"
			size="2rem"
			@click="visible = true"
		/>

		<div
			v-show="breakpointHelper.isDesktop()"
			id="service-menu"
			class="service-menu__wrapper"
		>
			<VMenu
				attach="#service-menu"
				:close-on-content-click="false"
				eager
				max-height="520px"
				:max-width="menuWidth"
				:min-width="menuWidth"
				nudge-bottom="40px"
				:nudge-left="breakpointHelper.is('mdAndUp') ? '850px' : '515px'"
				transition="slide-y-transition"
				:value="visible"
				@input="breakpointHelper.isDesktop() ? visible = false : undefined"
				@keyup.esc="visible = false"
			>
				<ServiceMenuContent
					:home-href="homeHref"
					:home-to="homeTo"
					:identified-patient="identifiedPatient"
					:services-patient="servicesPatient"
					:services-ps="servicesPs"
				/>
			</VMenu>
		</div>

		<AmeliproDialog
			v-if="!breakpointHelper.isDesktop()"
			v-model="visible"
			fullscreen
			:labelledby="modalId"
			unique-id="service-menu-dialog"
			@change="emitChangeEvent"
		>
			<template #header>
				<h2
					:id="modalId"
					class="ma-0 text-h4"
				>
					Liste des services
				</h2>
			</template>

			<template #default>
				<ServiceMenuContent
					:home-href="homeHref"
					:home-to="homeTo"
					:identified-patient="identifiedPatient"
					:services-patient="servicesPatient"
					:services-ps="servicesPs"
				/>
			</template>
		</AmeliproDialog>
	</div>
</template>

<script setup lang="ts">
	import { PropType, computed, onMounted, ref, watch } from 'vue';
	import AmeliproDialog from '../AmeliproDialog/AmeliproDialog.vue';
	import AmeliproIconBtn from '../AmeliproIconBtn/AmeliproIconBtn.vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { RawLocation } from 'vue-router';
	import { Service } from '../ServiceBtn/types';
	import ServiceMenuContent from '../ServiceMenuContent';
	import { VMenu } from 'vuetify/lib';

	const props = defineProps({
		homeHref: {
			type: String,
			default: undefined,
		},
		homeTo: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
		icon: {
			type: String,
			default: 'applications',
		},
		identifiedPatient: {
			type: Boolean,
			default: false,
		},
		servicesPatient: {
			type: Array as PropType<Service[]>,
			default: () => [],
		},
		servicesPs: {
			type: Array as PropType<Service[]>,
			required: true,
		},
		value: {
			type: Boolean,
			default: false,
		},
	});

	const modalId = 'service-menu-title';
	const breakpointHelper = new BreakpointHelper('smAndUp');
	const visible = ref(false);

	const menuWidth = computed<string>(() => {
		let width = '564px';

		if (breakpointHelper.is('mdAndUp')) {
			width = '900px';
		}

		return width;
	});

	const closeMenu = (event: KeyboardEvent): void => {
		if (event.code === 'Escape' && visible.value) {
			visible.value = false;
			document.getElementById('service-menu-btn')?.focus();
		}
	};

	const setMenuAttrs = (): void => {
		const element = document.querySelector('#service-menu')?.querySelector('.v-menu__content');
		element?.setAttribute('aria-label', 'Liste des services');
		element?.setAttribute('aria-modal', 'true');
		element?.setAttribute('role', 'dialog');
	};

	const emit = defineEmits(['change']);
	const emitChangeEvent = (): void => {
		visible.value = false;
		emit('change', false);
	};

	watch(() => props.value, () => {
		visible.value = props.value;
	}, { immediate: true });

	onMounted(() => {
		setMenuAttrs();
		window.addEventListener('keyup', closeMenu);
	});

	// Rendre publique la méthode closeMenu permet à un bouton ou à un composant externe de fermer le menu
	defineExpose({ closeMenu });

	// @Component<ServiceMenu>({
	// 	model: {
	// 		prop: 'value',
	// 		event: 'change',
	// 	},
	// 	watch: {
	// 		value: {
	// 			handler(value: boolean) {
	// 				this.visible = value;
	// 			},
	// 			immediate: true,
	// 		},
	// 	},
	// })
</script>

<style lang="scss" scoped>
	.service-menu {
		position: relative;
	}
</style>
